import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Importa i tuoi file di traduzione
import translationIT from "./locales/it.json";
import translationEN from "./locales/en.json";
import translationDE from "./locales/de.json";
import translationPL from "./locales/pl.json";

i18n
  .use(initReactI18next) // <- Importante
  .init({
    resources: {
      it: { translation: translationIT },
      // en: { translation: translationEN },
      // de: { translation: translationDE },
      // pl: { translation: translationPL },
    },
    lng: "it",          // lingua di default
    fallbackLng: "it",
    interpolation: { escapeValue: false },
  });

export default i18n;